import type { RouteRecordRaw } from 'vue-router';

// Import page components from views
import Reports from '../views/Reports.vue';
import ReportOverview from '../views/ReportOverview.vue';
import ReportGradeOverview from '../views/ReportGradeOverview.vue';
import ReportGateway from '../views/ReportGateway.vue';

// Define application routes
export const routes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    props: (route) => ({
      formats: route.query.formats ? (Array.isArray(route.query.formats) ? route.query.formats : [route.query.formats]) : [],
      grades: route.query.grades ? (Array.isArray(route.query.grades) ? route.query.grades : [route.query.grades]) : [],
    }),
  },
  {
    path: '/reports/:subject',
    name: 'reports-subject',
    component: Reports,
    props: (route) => ({
      subject: route.params.subject,
      formats: route.query.formats ? (Array.isArray(route.query.formats) ? route.query.formats : [route.query.formats]) : [],
      grades: route.query.grades ? (Array.isArray(route.query.grades) ? route.query.grades : [route.query.grades]) : [],
    }),
  },
  {
    path: '/reports/overview/:id',
    name: 'report-overview',
    component: ReportOverview,
  },
  {
    path: '/reports/detail/:id/:grade(kindergarten|first-grade|second-grade|third-grade|fourth-grade|fifth-grade|sixth-grade|seventh-grade)',
    name: 'report-grade-overview',
    component: ReportGradeOverview,
  },
  {
    path: '/reports/detail/:id/:grade(kindergarten|first-grade|second-grade|third-grade|fourth-grade|fifth-grade|sixth-grade|seventh-grade)/:gateway',
    name: 'report-gateway',
    component: ReportGateway,
  },
];
